<template>
  <div>
    <div class="result-percent">
      <div class="result-percent-content">
        <div class="percent-item">
          <div class="round-icon blue">B</div>
          <div>: {{ history.banker }}%</div>
        </div>
        <div class="percent-item">
          <div class="round-icon red">P</div>
          <span>: {{ history.player }}%</span>
        </div>
        <div class="percent-item">
          <div class="round-icon green">T</div>
          <span>: {{ history.tie }}%</span>
        </div>
      </div>
    </div>
    <div class="result">
      <div class="result-content">
        <div v-for="(column, index) in history.result" :key="index"
          class="result-row"
        >
          <div
            v-for="({ score, value, round, createdDate }, index1) in column"
            :key="index1"
            class="result-item"
          >
            <i
              :id="'result_' + round"
              :ref="'result_' + round"
              :title="setTitle(round, createdDate)"
              :score="JSON.stringify(score)"
              :value="value"
              :round="round"
              :createdDate="createdDate"
              :class="setClass(value)"
              class="round-icon"
              @click="showDetail"
            />
          </div>
          <div v-for="i in remainingItems(column.length)" :key="i" class="result-item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatHistoryTitle } from '@utils/round.js';

export default {
  props: {
    table: { type: String, default: "" },
    history: { type: Object, default() { return {} } },
  },
  methods: {
    setClass: function(value) {
      let css = "RoadMapIcon-pending";
      switch(value){
        case "PLAYER":
          css = "blue";
          break;
        case "TIE":
          css = "green";
          break;
        case "BANKER":
          css = "red";
          break;
      }
      return css;
    },
    getText: function(value){
      if(value === null || value === ''){
        return "";
      }
      let text = "";
      switch(value){
        case "PLAYER":
          text = "P";
          break;
        case "TIE":
          text = "H";
          break;
        case "BANKER":
          text = "B";
          break;
      }
      return text;
    },
    setTitle: function(round, createdDate) {
      return formatHistoryTitle(round, createdDate);
    },
    showDetail: function(e){
      const id = e.target.getAttribute("id");
      const score = e.target.getAttribute("score");
      const value = e.target.getAttribute("value");
      const round = e.target.getAttribute("round");
      const createdDate = e.target.getAttribute("createdDate");
      const ref = this.$refs[id][0];

      const val = { ref, score, value, round, createdDate };
      this.$emit('showdetail', val);
    },
    remainingItems: function (length) {
      const items = [];
      if(length < 5){
        for(let i = length; i < 5; i ++){
          items.push(i);
        }
      }
      return items;
    }
  }
}
</script>

<style>

</style>
